export const colors = {
  primary: "#ff3c5b",
  secondary: "#8489FBFF",
  white: "#FFFFFF",
} as const;
